// Determine where a user should land after login based on their role and department.
// Workers → their department board. Chiefs → their first-chief dept board.
// Management/admin/architect → dashboard.
export function homePathForUser(user) {
  if (!user) return "/";

  // Mali müşavir → doğrudan muhasebe ana ekranı
  if ((user.email || "").toLowerCase() === "muhasebe@akbkaravan.com") {
    return "/muhasebe";
  }

  // Hukuk müşaviri → doğrudan compliance panosu (read-only)
  if ((user.email || "").toLowerCase() === "hukuk@akbkaravan.com") {
    return "/finance/compliance";
  }

  // Mühendis (Hasan) → doğrudan TSE/TÜV workspace
  if ((user.email || "").toLowerCase() === "h.dirgen07@gmail.com" || user.role === "engineer") {
    return "/tse-tuv";
  }

  // Venni firma temsilcisi (Doruk) → sadece Venni tedarikçi portalı
  if (user.role === "venni_supplier") {
    return "/venni-portal";
  }

  // Workers with a department go straight to their board.
  const workerLike = ["production", "worker"];
  if (workerLike.includes(user.role) && user.department) {
    return DEPT_TO_PATH[user.department] || "/";
  }

  // Dept chiefs land on their first led dept.
  if (Array.isArray(user.chief_of) && user.chief_of.length > 0) {
    return DEPT_TO_PATH[user.chief_of[0]] || "/";
  }

  // Architect lands on the architect queue (İlk Start bekleyen araçlar).
  if (user.role === "architect") return "/architect";

  // Everyone else (admin, management, accounting, purchasing) → dashboard.
  return "/";
}

const DEPT_TO_PATH = {
  // v3 consolidated dept keys
  karoser: "/karoser",
  water: "/water",
  electrical: "/electrical",
  furniture: "/furniture",
  leak_test: "/leak-test",
  washing_delivery: "/washing-delivery",
  // legacy keys (redirected to consolidated dept via App.js Navigate)
  accessory: "/karoser",
  insulation: "/karoser",
  furniture_prod: "/furniture",
  furniture_asm: "/furniture",
  washing: "/washing-delivery",
  delivery: "/washing-delivery",
};
